import { Contract } from '@easy-lib/modules/user-agreements/contract';
import { Update } from '@ngrx/entity';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ContractAction = createActionGroup({
	source: 'contract',
	events: {
		load: emptyProps(),
		loadedError: emptyProps(),
		empty: emptyProps(),
		requestDone: emptyProps(),
		set: props<{ values: Contract[] }>(),
		update: props<Update<Contract>>(),
		upsert: props<{ value: Contract }>()
		// add: props<{ value: Position }>(),
	}
});
